const jetson_nano_tab_data = [
  {
    id: 0,
    title: "General",
    path: "general",
    dynamicRoute: true,
  },
  {
    id: 1,
    title: "Manual",
    path: "manual",
    dynamicRoute: true,
  },
  {
    id: 2,
    title: "Program",
    path: "program",
    dynamicRoute: true,
  },
  {
    id: 3,
    title: "Settings",
    path: "settings",
    dynamicRoute: true,
  },
  {
    id: 4,
    title: "Chat",
    path: "chat",
    dynamicRoute: true,
  },
];

export default jetson_nano_tab_data;
